import {
    getTestStory,
    regressionTest,
} from "../../../../../test-utils/regression";

describe("ux-slider-pagination", async () => {
    it("passes the regression test", async () => {
        await regressionTest({
            storyId: getTestStory("slider", "multiple-slides-per-column"),
            componentTag: "ux-slider",
            performActions: async (page) => {
                await page.addStyleTag({
                    content: ".ux-teaser-tile--vertical{height: 0px}",
                });
                await page.setViewport({ width: 300, height: 50 });
                await page.waitForTimeout(800);
                await page.click(
                    ".ux-slider-pagination__navigation-arrow--next"
                );
                await page.click(
                    ".ux-slider-pagination__navigation-arrow--next"
                );
                await page.click(
                    ".ux-slider-pagination__navigation-arrow--prev"
                );
                await page.click(
                    ".ux-slider-pagination__navigation-arrow--next"
                );
            },
        });
    });
});
